const MODULE_PATTERN = /\bmodule=([A-Za-z0-9_.-]+)/;
const addTrackJsModuleMetadata = (payload) => {
    if (payload.entry !== "console") {
        return;
    }
    const match = payload.message.match(MODULE_PATTERN);
    if (!match) {
        return;
    }
    const [, moduleName] = match;
    if (!moduleName) {
        return;
    }
    payload.metadata.push({
        key: "module",
        value: moduleName,
    });
};
export default addTrackJsModuleMetadata;
